// extracted by mini-css-extract-plugin
module.exports =  {"table":"WxJbSO8B247a9rpY3B5o"};